import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import config from "../../../configuration/config";
import { CountdownCalendar } from "../../parts/components/countdownCalendar";

export default function HomeOfferSection({ offers, filters, type }) {
    const { t: trans, i18n } = useTranslation(["common", "inputs", 'offers', "home", "info"]);
    const lang = (i18n.language || 'ar');

    return (
        <section className="sec" id="offers">
            <div className="ctn">
                <div className="stag">{trans("common:offers")}</div>
                <h2 className="sh">
                    {lang === 'ar' ? 'عروض حصرية على ' : 'Exclusive offers of '}
                    <span className="gn">{lang === 'ar' ? type === 'offer-vehicles' ? 'السيارات' : 'الصيانات' : type === 'offer-vehicles' ? 'Vehicles' : 'Maintenance'}</span>
                </h2>

                <div className="offers-grid">
                    {offers.map((offer, index) => (
                        <Link to={((offer.type === "Vehicles" || offer.type === "المركبات") ? "offers/vehicles/" + offer.slug : "offers/detail/" + offer.slug)} className="ofc" key={index} style={{ textDecoration: 'none', color: 'inherit' }}>
                            <div className="ofc-img">
                                <img src={config.FilePathURL + offer.image} alt={offer.title} />
                            </div>
                            <div className="ofc-body">
                                <div className="ofc-title">{offer.title}</div>
                                <div className="ofc-desc">{offer.excerpt}</div>
                                <div className="ofc-foot">
                                    <CountdownCalendar
                                        Total={offer.totalDays}
                                        start={offer.startDate}
                                        endDate={offer.endDate}
                                    />
                                    <span className="ofc-cta">{trans("common:show-more")}</span>
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>

                <div className="vc-more">
                    <Link to={"/offers"} style={{ textDecoration: 'none' }}>
                        <span>
                            {trans("common:show-more")}
                            <svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" fill="none" strokeWidth="2.5"><line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" /></svg>
                        </span>
                    </Link>
                </div>
            </div>
        </section>
    );
}